const UPDATE_PRODUCT_SEARCH_FOCUS_CLASS = 'UPDATE_PRODUCT_SEARCH_FOCUS_CLASS';

export default UPDATE_PRODUCT_SEARCH_FOCUS_CLASS;
